import moment from "moment"

const Card = ({ job, setDroppedJob }) => {
  return (
    <div className="relative shadow-md hover:shadow-xl shadow-slate-300 mt-5 mx-2 flex bg-gray-100 flex-col p-3 w-[335px] hover:border-[3px] hover:border-red-500 rounded-md transition-all duration-200 hover:bg-white">
      <span className="absolute -top-2 -right-1 bg-blue-100 text-blue-700 font-medium rounded-xl px-3 py-1 text-sm shadow">{job.jobType}</span>
      {parseInt(job.productedPieces) >= parseInt(job.totalPieces) && <span className="px-3 bg-violet-100 text-violet-600 absolute -top-2 py-1 right-[100px] font-medium shadow text-sm rounded-xl">Completed</span>}
      <div>
        {job.justNow && <span className="absolute -top-1 -left-1 px-2 py-[3px] bg-pink-600 shadow-md text-gray-100 rounded-full text-sm">New</span>}
      </div>
      <div className="flex justify-between w-full border-b-[1px] border-gray-400 pb-1 mb-1 mt-3">
        <span className='font-semibold text-base sm:text-md w-[270px]'>{job.jobType==='Embroidery' ? 'Job Order Name' : 'File Name'}</span>
        <span className='text-gray-700 truncate w-[165px] text-right' title={job.fileName} >{job.fileName}</span>
      </div>
      <div className="flex justify-between w-full border-b-[1px] border-gray-400 pb-1 mb-1">
        <span className='font-semibold text-base sm:text-md w-[270px]'>Name</span>
        <span className='text-gray-700 truncate w-[165px] text-right'>{job.name}</span>
      </div>
      {job.stiches && <div className="flex justify-between w-full border-b-[1px] border-gray-400 pb-1 mb-1">
        <span className='font-semibold text-base sm:text-md w-[270px]'>Stiches</span>
        <span className='text-gray-700 truncate w-[165px] text-right'>{job.stiches}</span>
      </div>}
      {job.jobType === 'Plotter' && <div className="flex justify-between w-full border-b-[1px] border-gray-400 pb-1 mb-1">
        <span className='font-semibold text-base sm:text-md w-[270px]'>Pieces For work</span>
        <span className='text-gray-700 truncate w-[165px] text-right'>{job.forwork}</span>
      </div>}
      <div className="flex justify-between w-full border-b-[1px] border-gray-400 pb-1 mb-1 group relative cursor-default">
        <span className='font-semibold text-base sm:text-md w-[270px]'>Work Inprogress by</span>
        <span className='text-gray-700 truncate w-[165px] text-right'>{job.workinprogressby.length>0?job.workinprogressby[0]?.name:'-----'}</span>
        <div className="opacity-0 -z-10 group-hover:z-10 group-hover:opacity-100 flex absolute right-0 top-7 bg-white py-2 rounded-md shadow-md flex-col transition-all duration-500">
          {job.workinprogressby?.map((e) => (
            <span key={e.id} className='text-gray-700 px-4 py-1 hover:bg-gray-100 font-medium cursor-pointer'>{e.name}</span>
          ))}
        </div>
      </div>
      <div className="flex justify-between w-full border-b-[1px] border-gray-400 pb-1 mb-1">
        <span className='font-semibold text-base sm:text-md w-[270px]'>Total pieces</span>
        <span className='text-gray-700 truncate w-[165px] text-right'>{job.totalPieces}</span>
      </div>
      <div className="flex justify-between w-full border-b-[1px] border-gray-400 pb-1 mb-1">
        <span className='font-semibold text-base sm:text-md w-[270px]'>Bad Pieces</span>
        <span className='text-gray-700 truncate w-[165px] text-right'>{job.bad}</span>
      </div>
      <div className="flex justify-between w-full border-b-[1px] border-gray-400 pb-1 mb-1">
        <span className='font-semibold text-base sm:text-md w-[270px]'>Producted Pieces</span>
        <span className='text-gray-700 truncate w-[165px] text-right'>{job.productedPieces}</span>
      </div>
      <div className="flex justify-between w-full border-b-[1px] border-gray-400 pb-1 mb-1">
        <span className='font-semibold text-base sm:text-md w-[270px]'>Date</span>
        <span className='text-gray-700 truncate w-[165px] text-right'>{job.delivery}</span>
      </div>
      <div className="flex justify-between items-center w-full border-b-[1px] border-gray-400 pb-1 mb-1">
        <span className='font-semibold text-base sm:text-md'>Created At</span>
        <span className='text-gray-700 truncate text-right text-sm'>{moment(new Date(job.createdAt)).format('LLL')}</span>
      </div>

      {/* <div className="flex justify-end space-x-2 mt-1">
        <button className="bg-blue-200 py-1 px-3 border border-green-500 text-green-600 rounded-2xl shadow font-semibold hover:bg-green-500 hover:text-white transition-all duration-300 ">Update</button>
        <button className="bg-red-200 py-1 px-3 border border-red-500 rounded-2xl text-red-600 font-semibold hover:bg-red-500 shadow hover:text-white transition-all duration-300" onClick={() => {
          setDroppedJob(job)
        }}>Delete</button>
      </div> */}
    </div>
  )
}

export default Card
